module.exports = __webpack_public_path__ + "img/DE00835.58019071.png";